import type { ReactNode } from 'react';

import { AppRouter } from '@/app/routes/router.tsx';
import { AppProvider } from '@/app/provider.tsx';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export function AppMain(): ReactNode {
  const queryClient = new QueryClient();
  return (
    <AppProvider>
      <QueryClientProvider client={queryClient}>
        <AppRouter />
      </QueryClientProvider>
    </AppProvider>
  );
}
